import type { ReactNode } from 'react';
import styles from './FilterChip.module.css';

type FilterChipVariant = 'selectable' | 'removable' | 'negative';

type FilterChipProps = {
  children: ReactNode;
  onClick: () => void;
  variant?: FilterChipVariant;
  isActive?: boolean;
  ariaLabel?: string;
  pressed?: boolean;
  leading?: ReactNode;
  prefix?: ReactNode;
  suffix?: ReactNode;
};

export default function FilterChip({
  children,
  onClick,
  variant = 'selectable',
  isActive = false,
  ariaLabel,
  pressed,
  leading,
  prefix,
  suffix,
}: FilterChipProps) {
  const className = [
    styles.chip,
    variant === 'removable' ? styles.removable : variant === 'negative' ? styles.negative : styles.selectable,
    isActive ? styles.active : '',
  ].filter(Boolean).join(' ');

  return (
    <button
      type="button"
      className={className}
      onClick={onClick}
      aria-label={ariaLabel}
      aria-pressed={pressed}
    >
      {prefix && <span className={styles.type}>{prefix}</span>}
      {leading}
      <span className={styles.label}>{children}</span>
      {suffix && <span className={styles.close} aria-hidden="true">{suffix}</span>}
    </button>
  );
}
